import { ReactNode } from "react"
import { Drawer, DrawerDirection } from "@nova/component-drawer"
import { NotificationsPanel } from "./NotificationPanel"
import { invalidateNotifications, useNotifications } from "./NotificationQueries"

export const NotificationsDrawer = ({
    direction,
    renderTrigger,
}: {
    direction: DrawerDirection
    renderTrigger: (hasUnreadNotifications: boolean) => ReactNode
}) => {
    const { unreadCount } = useNotifications()

    return (
        <Drawer onOpenChange={(isOpen) => isOpen && invalidateNotifications()}>
            <Drawer.Trigger>{renderTrigger(unreadCount > 0)}</Drawer.Trigger>
            <Drawer.Menu className="w-[448px] max-w-[100vw]" direction={direction}>
                <NotificationsPanel />
            </Drawer.Menu>
        </Drawer>
    )
}
